import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollToTop = () => {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip scroll on initial mount to improve TTI
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    
    // Use instant scroll on route change (faster than smooth)
    window.scrollTo(0, 0);
  }, [pathname]);
};

export default useScrollToTop;
